import React from "react";
import RecruiterLayerBlueprint from "components/blueprints/RecruiterLayerBlueprint";
import RecruiterClientsTableHeader from "./RecruiterClientsTableHeader";
import RecruiterClientsPageTable from "./RecruiterClientsPageTable";

function RecruiterClientsPage() {
  return (
    <section className="bg-gray-100" style={{ minHeight: "calc(100vh - 60px)" }}>
      <div className="container mx-auto">
        <div className="bg-white pt-2 pb-6 shadow-md blur-2 text-opacity-15 spread-0 mb-[30px]">
          <RecruiterClientsTableHeader />
          <RecruiterClientsPageTable />
        </div>
      </div>
    </section>
  )
}

export default RecruiterLayerBlueprint(RecruiterClientsPage);
